// extracted by css-extract-rspack-plugin
export default {"descriptions":"descriptions-hnOa1Q","descriptionsItem":"descriptionsItem-Ob5hPj"};